export const appPath = '/portal/';
export const GROUP_ADMIN = 'group_admin';
export const defaultEndpoint = `${window.location.protocol}//${window.location.host}/data/graphql`;
export const preferredContactMethods = {
  email: { value: 'EMAIL', label: 'E-mail' },
  phone: { value: 'PHONE', label: 'Mobile Phone or Home Phone' }
};
export const canadaProvinces = [
  { abbr: 'AB', name: 'Alberta' },
  { abbr: 'BC', name: 'British Columbia' },
  { abbr: 'MB', name: 'Manitoba' },
  { abbr: 'NB', name: 'New Brunswick' },
  { abbr: 'NL', name: 'Newfoundland and Labrador' },
  { abbr: 'NS', name: 'Nova Scotia' },
  { abbr: 'ON', name: 'Ontario' },
  { abbr: 'QC', name: 'Quebec' },
  { abbr: 'SK', name: 'Saskatchewan' },
];
export const defaultCanadaProvince = 'NS';
